import { render, staticRenderFns } from "./NovaPoshtaTable.vue?vue&type=template&id=39f73963&scoped=true"
import script from "./NovaPoshtaTable.vue?vue&type=script&lang=js"
export * from "./NovaPoshtaTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f73963",
  null
  
)

export default component.exports